import { render, staticRenderFns } from "./ColorSpectrumPicker.vue?vue&type=template&id=71b441f8&scoped=true&"
import script from "./ColorSpectrumPicker.vue?vue&type=script&lang=js&"
export * from "./ColorSpectrumPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorSpectrumPicker.vue?vue&type=style&index=0&id=71b441f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b441f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VList,VListItem,VListItemAction,VListItemContent,VListItemGroup,VListItemTitle})
